import {
    Modal,
    Paper,
    Slide,
    IconButton,
    Typography,
    useTheme,
    Container,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'
import { MessageForm } from './MessageForm'
import { FlexDiv } from '../../components'

interface Props {
    open: boolean
    channelId: number
    disableMessaging?: boolean
    onClose: () => void
    afterCreateMessage: () => void
}

export const MessageModal = (props: Props) => {
    const { open, channelId, disableMessaging, onClose, afterCreateMessage } =
        props

    const theme = useTheme()

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
            }}
        >
            <Slide direction="up" in={open}>
                <Paper
                    style={{
                        width: '90%',
                        height: '90vh',
                        maxWidth: '800px',
                        maxHeight: '800px',
                    }}
                >
                    <FlexDiv
                        style={{
                            flexDirection: 'column',
                            flex: 1,
                            height: '100%',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: theme.spacing(2),
                                paddingRight: theme.spacing(1),
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                marginBottom: theme.spacing(1),
                            }}
                        >
                            <Typography variant="h6">Messages</Typography>
                            <IconButton onClick={onClose} size="small">
                                <CloseIcon />
                            </IconButton>
                        </div>

                        <MessageForm
                            theme={theme}
                            channelId={channelId}
                            disableMessaging={disableMessaging}
                            afterCreateMessage={afterCreateMessage}
                        />
                    </FlexDiv>
                </Paper>
            </Slide>
        </Modal>
    )
}
